import React from 'react';

export interface AudioPlaybackSettingsValue {
  audio_max_plays?: number | null;
  audio_allow_pause?: boolean;
  audio_allow_seek?: boolean;
}

interface AudioPlaybackSettingsProps {
  value: AudioPlaybackSettingsValue;
  onChange: (changes: AudioPlaybackSettingsValue) => void;
}

export const describeAudioPlayback = (value: AudioPlaybackSettingsValue): string => {
  const parts = [
    value.audio_max_plays
      ? `${value.audio_max_plays} play${value.audio_max_plays !== 1 ? 's' : ''} per audio`
      : 'Unlimited plays',
    value.audio_allow_pause === false ? 'no pausing' : 'pausing allowed',
    value.audio_allow_seek === false ? 'no skipping' : 'skipping allowed'
  ];
  return parts.join(', ');
};

const AudioPlaybackSettings: React.FC<AudioPlaybackSettingsProps> = ({ value, onChange }) => (
  <div className="form-group">
    <label>Audio Playback Rules</label>
    <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
      <input
        type="number"
        id="audio_max_plays"
        className="form-control"
        value={value.audio_max_plays || ''}
        onChange={(e) => onChange({ audio_max_plays: e.target.value ? parseInt(e.target.value) : null })}
        placeholder="Unlimited"
        min="1"
        max="20"
        style={{ maxWidth: '150px' }}
      />
      <span>plays per audio file</span>
    </div>
    <small className="form-text">
      How many times participants can play each audio file. Leave empty for unlimited.
      Questions that share the same audio share the same limit.
    </small>

    <div style={{ marginTop: '10px' }}>
      <label>
        <input
          type="checkbox"
          checked={value.audio_allow_pause !== false}
          onChange={(e) => onChange({ audio_allow_pause: e.target.checked })}
          style={{ marginRight: '8px' }}
        />
        Allow pausing
      </label>
    </div>
    <div>
      <label>
        <input
          type="checkbox"
          checked={value.audio_allow_seek !== false}
          onChange={(e) => onChange({ audio_allow_seek: e.target.checked })}
          style={{ marginRight: '8px' }}
        />
        Allow skipping forward/back (seeking)
      </label>
    </div>
    <small className="form-text">
      When pausing is disabled, audio plays through to the end once started.
    </small>
  </div>
);

export default AudioPlaybackSettings;
